import { render, staticRenderFns } from "./Profil.vue?vue&type=template&id=5aae306a&"
import script from "./Profil.vue?vue&type=script&lang=js&"
export * from "./Profil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports